const getAPIUrl = async () => {
  // con axios me da out of memory...
  const request = await fetch('/static/connWeb.json')
  const response = await request.json()
  // si el environtment es development devuelvo hardcodeada la url de la API
  if (process.env.NODE_ENV === 'development') return `${process.env.VUE_APP_URL}`
  // si existe una url predeterminada uso esa
  if (response.url) return response.url
  // si no siempre retorna la url basada en el protocolo y puerto del archivo de configuración
  else return `${response.protocol}://${window.location.hostname}:${response.port}`
}

export default getAPIUrl
